import React from 'react';

import { Box } from '@chakra-ui/react';
import DisciplinaryActionsSettings from 'Deer/pages/Company/DisciplinaryActions/DisciplinaryActionsSettings/DisciplinaryActionsSettings';
import { BulkActionContextProvider } from 'Deer/pages/Company/DisciplinaryActions/components/BulkActionHeader/BulkActionContext';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

function MyCompanyDisciplinaryActionsSettingsIntent() {
  return (
    <BulkActionContextProvider>
      <Box position="relative">
        <Box p={!checkNewNavEnabled() ? 4 : 0}>
          <DisciplinaryActionsSettings />
        </Box>
      </Box>
    </BulkActionContextProvider>
  );
}

export { MyCompanyDisciplinaryActionsSettingsIntent };
